module.exports = __webpack_public_path__ + "static/media/rectangle-view-off.1da91148.svg";